import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import {
  selectGetItemStatus,
  selectGetStatus,
  selectItem,
  selectItems,
} from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";
import {
  myTasksAuditFilesListName,
  myTasksAuditListName,
  myTasksAuditQuestionsListName,
} from "src/api/config/myTasksAudit.config";
import {
  myTasksDependListName,
  myTasksLocationsListName,
} from "src/api/config/myTasksLists.config";
import {
  clearItem,
  clearItems,
  getItem,
  getItems,
  updateItem,
} from "src/modules/spItems/actions";
import moment from "moment";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "src/api/requests/updateFile";
import { MTAuditFiles } from "src/api/config";
import { useSearchParams } from "react-router-dom";

const AuditCard = ({
  zIndex,
  open,
  setOpen,
  auditID,
}: {
  zIndex: number;
  open: boolean;
  setOpen: any;
  auditID: number;
}) => {
  const dispatch = useAppDispatch();
  const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
  const [fields, setFields] = useState<any>([
    {
      type: "date",
      require: true,
      key: "DateOb",
      title: "Дата наблюдения",
      minDate: moment(new Date()).subtract(7, "days").toDate(),
      maxDate: moment(new Date()).toDate(),
      placeholder: "дд.мм.гггг",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "Observer",
      title: "ФИО наблюдателя",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      title: "Сотрудник, за кем проводили наблюдение",
      key: "ObservedType",
      placeholder: "Выберите из списка",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "ObservedUser",
      title: "ФИО, за кем проводили наблюдение",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "input",
      require: true,
      hide: true,
      key: "ObservedString",
      title: "ФИО, за кем проводили наблюдение",
      placeholder: "Введите имя или фамилию",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "Location",
      title: "Локация, где проводилось наблюдение",
      placeholder: "Не выбрано",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "Department",
      title: "Отдел, где проводилось наблюдение",
      placeholder: "Не выбрано",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "Region",
      title: "Участок, где проводилось наблюдение",
      placeholder: "Не выбрано",
      width: "w-full",
    },
  ]);
  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
  });
  const [formData, setFormData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [customLoading, setCustomLoading] = useState(true);
  const [auditQuestions, setAuditQuestions] = useState<any>([]);
  const locations: any = useAppSelector((state) =>
    selectItems(state, myTasksLocationsListName)
  );
  const dependencies: any = useAppSelector((state) =>
    selectItems(state, myTasksDependListName)
  );
  const [observedType, setObservedType] = useState("");

  const auditCard: any = useAppSelector((state) =>
    selectItem(state, myTasksAuditListName)
  );
  const users: any = useAppSelector(selectUsers);
  const [checkLoadUsers, setCheckLoadUsers] = useState(false);
  const filesArr: any = useAppSelector((state) =>
    selectItems(state, myTasksAuditFilesListName)
  );
  const [getDefaultFile, setGetDefaultFile] = useState(false);
  const filesStatus: any = useAppSelector((state) =>
    selectGetStatus(state, myTasksAuditFilesListName)
  );
  const statusAuditCard = useAppSelector((state) =>
    selectGetItemStatus(state, myTasksAuditListName)
  );
  const [renderAudit, setRenderAudit] = useState(false);
  const [openRemoveFileAuditModal, setOpenRemoveFileAuditModal] =
    useState<boolean>(false);
  const [getAudit, setGetAudit] = useState(false);
  const [auditKeys, setAuditKeys] = useState<any>([]);
  const [currentFormData, setCurrentFormData] = useState<any>(null);
  const [query, setQuery] = useSearchParams();

  //Расставляем опции селектов локации, типа сотрудников
  useEffect(() => {
    if (currentUser.id && renderAudit) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Location") {
          const options = locations.filter((location: any) => {
            if (
              currentUser.isAdmin ||
              (currentUser.isLocationEditorMyTasks &&
                currentUser.isLocationEditorMyTasks.length > 0 &&
                currentUser.isLocationEditorMyTasks.find(
                  (locationID: any) => locationID === location.ID
                )) ||
              (currentUser.isLocationAdminMyTasks &&
                currentUser.isLocationAdminMyTasks.length > 0 &&
                currentUser.isLocationAdminMyTasks.find(
                  (locationID: any) => locationID === location.ID
                ))
            ) {
              return true
            } else {
              return false
            }
          }).map((location: any) => {
            return {
              id: location.ID,
              name: location.Title,
              available: true,
            };
          });
          tempFieldsForm[i]["options"] = [...options];
        }
        if (tempFieldsForm[i]["key"] === "ObservedType") {
          tempFieldsForm[i]["options"] = [
            {
              id: 1,
              name: "Внутренний",
            },
            {
              id: 0,
              name: "Внешний",
            },
          ];
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [locations, currentUser, renderAudit]);

  useEffect(() => {
    if (dependenceFields["Location"] && renderAudit) {
      dispatch(
        getItems({
          listName: myTasksDependListName,
          filters: { Location: dependenceFields["Location"]["id"] },
        })
      );
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Department") {
          tempFieldsForm[i]["disabled"] = false;
        }
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (!dependenceFields["Location"] && renderAudit) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (
          tempFieldsForm[i]["key"] === "Department" ||
          tempFieldsForm[i]["key"] === "Region"
        ) {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (dependenceFields["Department"] && renderAudit) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = false;
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependenceFields, renderAudit]);

  //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

  useEffect(() => {
    if (renderAudit) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (dependenceFields["Location"]) {
          if (tempFieldsForm[i]["key"] === "Department") {
            const options = dependencies
              .filter(
                (dependence: any) =>
                  dependence.Location.ID === dependenceFields["Location"]["id"]
              )
              .map((dependence: any) => {
                return {
                  id: dependence.Departament.ID,
                  name: dependence.Departament.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
        if (dependenceFields["Department"]) {
          if (tempFieldsForm[i]["key"] === "Region") {
            const options = dependencies
              .filter(
                (dependence: any) =>
                  dependence.Location.ID ===
                  dependenceFields["Location"]["id"] &&
                  dependence.Departament.ID ===
                  dependenceFields["Department"]["id"]
              )
              .map((dependence: any) => {
                return {
                  id: dependence.Region.ID,
                  name: dependence.Region.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependencies, renderAudit]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      console.log("FORM_DATA_AUDIT_UPDATE: ", formData);
      setCustomLoading(true);
      let tempAuditObj: any = {};
      Object.keys(formData).map((key) => {
        if (auditKeys.some((auditKey: string) => auditKey === key)) {
          if (Array.isArray(formData[key])) {
            formData[key].sort((a: any, b: any) => {
              return a.localeCompare(b);
            });
            tempAuditObj[key] = formData[key];
          } else {
            tempAuditObj[key] = formData[key];
          }
        }
      });
      const sendData = {
        Audit: JSON.stringify(tempAuditObj),
        Title: `Поведенческий аудит от ${moment(
          (typeof formData.DateOb.startDate === "string" &&
            new Date(formData.DateOb.startDate)) ||
          formData.DateOb.startDate
        ).format("DD.MM.YYYY")}`,
        DateOb:
          (typeof formData.DateOb.startDate === "string" &&
            new Date(formData.DateOb.startDate)) ||
          formData.DateOb.startDate,
        Observer: formData.Observer[0]["value"],
        ObserverDepartment:
          (users[formData.Observer[0]["value"]] &&
            users[formData.Observer[0]["value"]]["department"]) ||
          "",
        ObserverEmail: formData.Observer[0]["value"],
        ObservedType: formData.ObservedType.name,
        ObservedUser:
          formData.ObservedUser && formData.ObservedUser[0]["value"],
        ObservedUserEmail:
          formData.ObservedUser && formData.ObservedUser[0]["value"],
        ObservedString: formData.ObservedString,
        Location: formData.Location.id,
        Department: formData.Department.id,
        Region: formData.Region.id,
        Description: formData.Description.trim() + " ",
        Feedback: formData.Feedback && formData.Feedback.trim() + " ",
        ID: auditID,
      };
      updateItemRequest({
        listName: myTasksAuditListName,
        body: sendData,
      }).then((value: any) => {
        const updateAuditID = value[0];
        let uploadAuditFilesRequests: any = [];
        formData.AuditFiles &&
          formData.AuditFiles.length > 0 &&
          formData.AuditFiles.filter(
            (file: any) => !file.id && !file.ID
          ).forEach((file: any) => {
            uploadAuditFilesRequests = [
              ...uploadAuditFilesRequests,
              uploadFile(
                file,
                myTasksAuditFilesListName,
                MTAuditFiles.idFolder,
                MTAuditFiles.apiStrapi,
                MTAuditFiles.createElemInStrapi
              ),
            ];
          });
        if (uploadAuditFilesRequests.length > 0) {
          Promise.all(uploadAuditFilesRequests).then((values: any) => {
            let idsAuditFiles: number[] = [];
            values.length > 0 &&
              values.forEach((value: any) => {
                idsAuditFiles = [...idsAuditFiles, value.id];
              });
            if (idsAuditFiles.length > 0) {
              let updateAuditFilesRequests: any = [];
              idsAuditFiles.forEach((idFile: number) => {
                updateAuditFilesRequests = [
                  ...updateAuditFilesRequests,
                  updateFile(
                    myTasksAuditFilesListName,
                    { Audit: updateAuditID, ID: idFile },
                    MTAuditFiles.apiStrapi,
                    { Audit: auditID, id: idFile }
                  ),
                ];
              });
              if (updateAuditFilesRequests.length > 0) {
                Promise.all(updateAuditFilesRequests).then(() => {
                  setGetAudit(!getAudit);
                  setCustomLoading(false);
                  setCheckLoadUsers(false);
                });
              }
            }
          });
        } else {
          setGetAudit(!getAudit);
          setCustomLoading(false);
          setCheckLoadUsers(false);
        }
      });
    }
  }, [formData]);

  useEffect(() => {
    if (auditQuestions.length > 0) {
      setFields((prevState: []) => [...prevState, ...auditQuestions]);
      setRenderAudit(true);
    }
  }, [auditQuestions]);

  useEffect(() => {
    getItemsRequest({
      listName: myTasksAuditQuestionsListName,
      sortOrder: { name: "SortColumn", asc: true },
    }).then((results) => {
      const tempAuditQuestions = [...results.items];
      let auditKeys: string[] = [];
      let auditFieldsForm: any = [];
      tempAuditQuestions.forEach((item) => {
        auditFieldsForm = [
          ...auditFieldsForm,
          {
            type: item.TypeQuestion,
            require: item.Require,
            single: true,
            current: false,
            key: item.dc0t,
            title: item.Title,
            hide: item.DefaultHide,
            notice: item.Notice,
            noticeIcon: (item.Notice && true) || false,
            width: "w-full",
            optionsInputs:
              (item.Options &&
                item.Options.split(";").map((option) => option.trim())) ||
              [],
            condition: item.Condition && JSON.parse(item.Condition),
          },
        ];
        auditKeys = [...auditKeys, item.dc0t];
      });
      auditFieldsForm = [
        ...auditFieldsForm,
        ...[
          {
            type: "textArea",
            key: "Description",
            require: true,
            title: "Описание",
            placeholder:
              "Опишите операцию/процесс/действие, за которой(ым) проводилось наблюдение",
            width: "w-full",
          },
          {
            type: "textArea",
            key: "Feedback",
            require: false,
            title: "Обратная связь от человека, за которым наблюдали",
            placeholder: "Введите описание",
            width: "w-full",
          },
          {
            type: "file",
            key: "AuditFiles",
            multiple: true,
            require: false,
            width: "w-full",
            title: "Перетащите документ сюда или",
            titleFile: "выберите файл",
            placeholder: "Размер файла не более 50MB",
          },
        ],
      ];
      setAuditQuestions([...auditFieldsForm]);
      setAuditKeys([...auditKeys]);
      setCustomLoading(false);
    });
    return () => {
      dispatch(clearItem({ listName: myTasksAuditListName }));
      dispatch(clearItems({ listName: myTasksAuditFilesListName }));
    };
  }, []);

  useEffect(() => {
    if (auditID) {
      getItemsRequest({ listName: myTasksAuditListName, filters: { ID: auditID } }).then(results => {
        if (results.items.length === 0) {
          alert("Карточка аудита не найдена или удалена");
          query.delete("auditCard");
          setQuery(query);
          return;
        } else {
          dispatch(
            getItem({ listName: myTasksAuditListName, filters: { ID: auditID } })
          );
          dispatch(
            getItems({
              listName: myTasksAuditFilesListName,
              filters: {
                Audit: auditID,
                ForHistory: false,
              },
              sortOrder: { name: "ID", desc: true },
            })
          );
        }
      });
    }
  }, [auditID, getAudit]);

  useEffect(() => {
    if (
      renderAudit &&
      auditCard &&
      Object.keys(auditCard).length > 0 &&
      !checkLoadUsers &&
      Object.keys(users).length > 0
    ) {
      console.log('auditCard: ', auditCard);
      if (auditCard.Observer) {
        if (auditCard.ObservedUser) {
          if (
            users[auditCard.Observer.Email] &&
            users[auditCard.ObservedUser.Email]
          ) {
            setCheckLoadUsers(true);
          }
        } else {
          if (users[auditCard.Observer.Email]) {
            setCheckLoadUsers(true);
          }
        }
      }
      let tempDefaultValues: any = {};
      Object.keys(auditCard).map((key: string, idx: number) => {
        const field = auditCard[key];
        if (field && (key === "Observer" || key === "ObservedUser")) {
          tempDefaultValues[key] = [
            {
              label:
                (users[field.Email] && users[field.Email].displayName) ||
                field.Name,
              value:
                (users[field.Email] && users[field.Email].email) || field.Email,
              avatar: (users[field.Email] && users[field.Email].avatar) || null,
              email:
                (users[field.Email] && users[field.Email].email) || field.Email,
            },
          ];
        } else if (key === "DateOb") {
          tempDefaultValues[key] = {
            startDate: field.toDate(),
            endDate: field.toDate(),
          };
        } else if (
          key === "Location" ||
          key === "Department" ||
          key === "Region"
        ) {
          tempDefaultValues[key] = {
            id: field.ID,
            name: field.Title,
          };
        } else if (key === "Author") {
          return false;
        } else if (key === "ObservedType") {
          setObservedType(field);
          tempDefaultValues[key] = {
            id: idx,
            name: field,
          };
        } else if (key === "Audit") {
          if (field) {
            const auditObj = JSON.parse(field);
            auditQuestions.forEach((question) => {
              if (
                question.type === "checkbox" &&
                !auditObj.hasOwnProperty(question.key)
              ) {
                auditObj[question.key] = [];
              }
            });
            if (auditObj) {
              tempDefaultValues = { ...tempDefaultValues, ...auditObj };
            }
          }
        } else {
          tempDefaultValues[key] = field;
        }
      });
      setDefaultValues((prevState: any) => {
        return { ...prevState, ...tempDefaultValues };
      });
      setCurrentFormData({ ...tempDefaultValues });
    }
  }, [auditCard, users, checkLoadUsers, renderAudit]);

  useEffect(() => {
    if (observedType && renderAudit && auditCard &&
      Object.keys(auditCard).length > 0) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (observedType === "Внутренний") {
          if (tempFieldsForm[i]["key"] === "ObservedUser") {
            tempFieldsForm[i]["hide"] = false;
            tempFieldsForm[i]["require"] = true;
          }
          if (tempFieldsForm[i]["key"] === "ObservedString") {
            tempFieldsForm[i]["hide"] = true;
            tempFieldsForm[i]["require"] = false;
          }
        }
        if (observedType === "Внешний") {
          if (tempFieldsForm[i]["key"] === "ObservedUser") {
            tempFieldsForm[i]["hide"] = true;
            tempFieldsForm[i]["require"] = false;
          }
          if (tempFieldsForm[i]["key"] === "ObservedString") {
            tempFieldsForm[i]["hide"] = false;
            tempFieldsForm[i]["require"] = true;
          }
          setDefaultValues((prevState: any) => {
            return { ...prevState, ...{ ObservedString: auditCard.ObservedString } };
          });
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [observedType, renderAudit, auditCard]);

  useEffect(() => {
    if (renderAudit && currentFormData) {
      console.log("currentFormData: ", currentFormData);
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        const field = tempFieldsForm[i];
        if (field.condition) {
          let conditionObj: any = {};
          Object.keys(field.condition).map((key: string) => {
            if (typeof currentFormData[key] === "object") {
              if (currentFormData[key]["name"] === field.condition[key]) {
                conditionObj[key] = true;
              }
            } else {
              if (currentFormData[key] === field.condition[key]) {
                conditionObj[key] = true;
              }
            }
          });
          if (
            Object.keys(field.condition).length ===
            Object.keys(conditionObj).length
          ) {
            tempFieldsForm[i]["hide"] = false;
          } else {
            tempFieldsForm[i]["hide"] = true;
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [currentFormData, renderAudit]);

  useEffect(() => {
    if (statusAuditCard === "SUCCESS" && filesStatus === "SUCCESS") {
      setGetDefaultFile(false);
      setCheckLoadUsers(false);
    }
  }, [statusAuditCard, filesStatus]);

  //Определяем файл по дефолту
  useEffect(() => {
    if (filesArr.length > 0 && !getDefaultFile && filesStatus === "SUCCESS") {
      setDefaultValues((prevState: any) => {
        return { ...prevState, AuditFiles: filesArr };
      });
      setGetDefaultFile(true);
    }
  }, [getDefaultFile, filesArr, filesStatus]);

  const removeAuditFileHandle = () => {
    const idRemoveFile = localStorage.getItem("removeAuditFile");
    localStorage.setItem("removeAuditFile", "");
    setOpenRemoveFileAuditModal(false);
    dispatch(
      updateItem({
        listName: myTasksAuditFilesListName,
        body: { ID: idRemoveFile, ForHistory: true },
      })
    );
  };

  useEffect(() => {
    if (
      auditCard &&
      Object.keys(auditCard).length > 0 &&
      currentUser.id &&
      renderAudit
    ) {
      if (
        !currentUser.isAdmin &&
        currentUser.email !== auditCard.AuthorEmail &&
        (!currentUser.isLocationEditorMyTasks ||
          (currentUser.isLocationEditorMyTasks &&
            !currentUser.isLocationEditorMyTasks.some(
              (locationID: number) => locationID === auditCard.Location.ID
            ))) &&
        (!currentUser.isLocationAdminMyTasks ||
          (currentUser.isLocationAdminMyTasks &&
            !currentUser.isLocationAdminMyTasks.some(
              (locationID: number) => locationID === auditCard.Location.ID
            )))
      ) {
        const tempFieldsForm = [...fields];
        for (let i = 0; i < tempFieldsForm.length; i++) {
          tempFieldsForm[i]["disabled"] = true;
        }
        setFields([...tempFieldsForm]);
      }
    }
  }, [auditCard, fields, currentUser, renderAudit]);

  return (
    <>
      <DrawerComponent zIndex={zIndex} open={open} toggleDrawer={setOpen}>
        <div className="flex flex-col p-10 shrink">
          <h1 className="mb-8 text-black">{auditCard && auditCard.Title}</h1>
          {((customLoading ||
            filesStatus === "LOADING" ||
            statusAuditCard === "LOADING") && (
              <div className="flex items-center justify-center w-full mt-5 mb-5">
                <Loading />
              </div>
            )) || (
              <Form
                type="audit_card_my_tasks"
                setFormData={setFormData}
                fieldsForm={fields}
                defaultValues={defaultValues}
                setDependenceFields={setDependenceFields}
                setObservedType={setObservedType}
                auditID={auditID}
                listUploadFiles={myTasksAuditFilesListName}
                setOpenRemoveFileCommentModal={setOpenRemoveFileAuditModal}
                openRemoveFileCommentModal={openRemoveFileAuditModal}
                setCurrentFormData={setCurrentFormData}
              />
            )}
        </div>
      </DrawerComponent>
      {/*Модалка удаления файла у аудита */}
      <Modal
        zIndex={zIndex ? zIndex + 20 : 70}
        modalClassName="min-h-px flex gap-5 p-10"
        open={openRemoveFileAuditModal}
        toggleDialog={setOpenRemoveFileAuditModal}
      >
        <h2>Подтвердите действие</h2>

        <p>Вы уверены, что хотите удалить этот файл?</p>
        <div className="w-full border-t" />
        <footer className="w-full flex justify-center">
          <TGButton
            color="white"
            onClick={(e) =>
              setOpenRemoveFileAuditModal(!openRemoveFileAuditModal)
            }
          >
            Отмена
          </TGButton>
          <TGButton
            color="bluedark"
            onClick={() => {
              removeAuditFileHandle();
            }}
          >
            Удалить файл
          </TGButton>
        </footer>
      </Modal>
    </>
  );
};

export default AuditCard;
